// 
//import
import {multipleNewSelector} from "./multiple-selector";
import {singleNewSelector} from "./single-selector";

import {getRefseqRankValue, getStringifyRefseqSequenceById,} from "../../selector";
import {getRefseqSequenceSuggestionEngine} from "../../selector/suggestion-engine";
import {taxo_rank} from "../../reducer/taxonomic-rank";

// Code start here
const biob_type = "refseq_sequence";

export function refseqSequenceSelector(
  multiple,
  preselected_biob_ids = [],
  html_class = "",
  hide_rapid_selector = true
) {
  return multiple
    ? multipleNewSelector(
        biob_type,
        getStringifyRefseqSequenceById,
        getRefseqSequenceSuggestionEngine,
        getRefseqRankValue,
        taxo_rank,
        preselected_biob_ids,
        hide_rapid_selector
      )
    : singleNewSelector(
        biob_type,
        getRefseqSequenceSuggestionEngine,
        html_class
      );
}
